import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../app/hooks';
import { TpUserInfo } from '../../data/interfaces';

export enum PERMISSIONS {
  SYSTEM_ADMIN = 'SystemAdmin',
  ORGANIZATION_ADMIN = 'OrganizationAdmin',
  ADMIN = 'Admin', // Either system admin or organization adming
  WRITE = 'Write',
  READ = 'Read',
}

function userHasPermission(user: TpUserInfo, permission: PERMISSIONS) {
  switch (permission) {
    case PERMISSIONS.SYSTEM_ADMIN:
      return user.isSystemAdmin;
    case PERMISSIONS.ORGANIZATION_ADMIN:
      return user.isOrganizationAdmin;
    case PERMISSIONS.ADMIN:
      return user.isSystemAdmin || user.isOrganizationAdmin;
    case PERMISSIONS.WRITE:
      return user.canWrite;
    case PERMISSIONS.READ:
      return true; // Currently all users can read.
    default:
      return false;
  }
}

export function AuthorizationGuard({
  children,
  permissions,
}: {
  children: JSX.Element;
  permissions: Array<PERMISSIONS>;
}) {
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  if (!permissions.every((permission) => userHasPermission(user, permission))) {
    // Change this behaviour to redirect to a 403 page if desired.
    return <Navigate to="/" state={{ from: location }} />;
  }

  return children;
}
